import React, { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Switch } from "./ui/switch";
import { MapPin } from "lucide-react";

// Admin → Sedi: raggio e testo predefinito degli avvisi di prossimità (Wallet + web app)
export default function ProximitySettingsCard() {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/settings/proximity").then(({ data }) => setS(data)).catch(() => {}); }, []);
  if (!s) return null;
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/settings/proximity", { enabled: s.enabled, radius_m: Number(s.radius_m), default_text: s.default_text }); setS({ ...s, ...data }); toast.success("Avvisi di prossimità salvati"); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <div className="card-elev p-4 space-y-3" data-testid="proximity-settings-card">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="text-[10px] uppercase tracking-widest text-zinc-500 flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5" /> Avvisi di prossimità · Wallet e web app</div>
        <label className="flex items-center gap-2 text-xs text-zinc-300">Attivi <Switch checked={!!s.enabled} onCheckedChange={(v) => setS({ ...s, enabled: v })} data-testid="proximity-enabled" /></label>
      </div>
      <p className="text-xs text-zinc-400">Apple Wallet mostra la card sul blocco schermo vicino alle sedi; Google Wallet invia una notifica (merchantLocations). Nella web app l'avviso compare quando il cliente la apre entro il raggio indicato, al massimo una volta al giorno per sede. Nel testo puoi usare <code>{"{branch}"}</code> per il nome della sede; ogni sede può avere un testo proprio.</p>
      <div className="grid sm:grid-cols-[140px_1fr_auto] gap-2 items-end">
        <div><div className="text-[11px] text-zinc-500 mb-1">Raggio web app (m)</div>
          <Input type="number" min={100} max={5000} step={50} value={s.radius_m} onChange={(e) => setS({ ...s, radius_m: e.target.value })} className="bg-zinc-950 border-zinc-800 h-10" data-testid="proximity-radius" /></div>
        <div><div className="text-[11px] text-zinc-500 mb-1">Testo predefinito</div>
          <Input value={s.default_text} maxLength={200} onChange={(e) => setS({ ...s, default_text: e.target.value })} className="bg-zinc-950 border-zinc-800 h-10" data-testid="proximity-default-text" /></div>
        <Button onClick={save} disabled={busy} className="bg-amber-500 hover:bg-amber-400 text-zinc-950 h-10" data-testid="proximity-save">Salva</Button>
      </div>
      <div className="text-[11px] text-zinc-500" data-testid="proximity-hits-today">Avvisi web app inviati oggi: <b className="text-zinc-300">{s.hits_today ?? 0}</b></div>
    </div>
  );
}
